import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import ChiliTemplateIframePageComponent from '@rotaryintl/brandcenter-chili-template-iframe-page-component';
import AboutThisTemplateTooltip from '@rotaryintl/brandcenter-about-this-template-tooltip';
import WBRString from '@component/WbrString';
import { useEffect } from 'react/cjs/react.production.min';
import ReactHtmlParser from 'react-html-parser';
const axios = require('axios');

const ChiliPublishTemplateComponent = (props) => {
  const isDocument = typeof document !== 'undefined';
  const isWindowContext = typeof window !== 'undefined';
  let [responseData, setResponseData] = React.useState('');
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
  const fetchData = () => {
    axios
      .get('/api/sitecore/ChilliPublishTemplate/Find?Id=' + getUrlParameter('id'))
      .then(function (response) {
        // handle success
        setResponseData(response.data);
      })
      .catch(function (error) {
        // handle error
      })
      .then(function () {
        // always executed
      });
  };
  if (responseData !== undefined) {
    var iframeURL = props.fields?.iframeurl?.value
      .replace('{{docid}}', responseData.chilipublishtemplateid)
      .replace('{{wsid}}', responseData.chilipublishtemplateworkspaceid);
  }
  useEffect(() => {
    fetchData();
  }, [isDocument, isWindowContext]);
  if (responseData.chilipublishtemplateid) {
    return (
      <>
        <AboutThisTemplateTooltip
          title={responseData.title}
          tooltipPosition={'bottom'}
          TooltipText={ReactHtmlParser(responseData.abouttext)[0]}
          smalldevicemessage={props.fields.smalldevicemessage?.value}
          saveMenuText={props.fields.savemytemplate?.value}
          savableOption={responseData.TemplateIsSavable}
          saveOption={props.fields.saveoption?.value}
          saveAsOption={props.fields.saveasoption?.value}
          updateTemplateName={props.fields.updatetemplatename?.value}
          saveTemplateButton={props.fields.savetemplatebutton?.value}
          formSubmitMessage={props.fields.formsubmitmessage?.value}
          templateNameHelpText={props.fields.templatenamehelptext?.value}
          invalidStringErrorText={props.fields.invalidstringerrortext?.value}
          closeHandler={() => {}}
        />
        <ChiliTemplateIframePageComponent template={iframeURL} />
      </>
    );
  }
  console.log(responseData);
  return (
    <>
      <div className="richtext">
        <WBRString tag="p">
          <Text field={props.fields?.notemplatefoundtext} />
        </WBRString>
      </div>
    </>
  );
};
export default ChiliPublishTemplateComponent;
